/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSegmentEventType } from './InternalApiSegmentEventType';
import {
    InternalApiSegmentEventTypeFromJSON,
    InternalApiSegmentEventTypeFromJSONTyped,
    InternalApiSegmentEventTypeToJSON,
    InternalApiSegmentEventTypeToJSONTyped,
} from './InternalApiSegmentEventType';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';

/**
 * 
 * @export
 * @interface InternalApiSegmentEvent
 */
export interface InternalApiSegmentEvent {
    /**
     * 
     * @type {InternalApiSegmentEventType}
     * @memberof InternalApiSegmentEvent
     */
    eventType: InternalApiSegmentEventType;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof InternalApiSegmentEvent
     */
    eventContent: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof InternalApiSegmentEvent
     */
    createdAt: Date;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiSegmentEvent
     */
    createdBy?: InternalApiUserBasicDetails;
}



/**
 * Check if a given object implements the InternalApiSegmentEvent interface.
 */
export function instanceOfInternalApiSegmentEvent(value: object): value is InternalApiSegmentEvent {
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('eventContent' in value) || value['eventContent'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function InternalApiSegmentEventFromJSON(json: any): InternalApiSegmentEvent {
    return InternalApiSegmentEventFromJSONTyped(json, false);
}

export function InternalApiSegmentEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSegmentEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'eventType': InternalApiSegmentEventTypeFromJSON(json['eventType']),
        'eventContent': json['eventContent'],
        'createdAt': (new Date(json['createdAt'])),
        'createdBy': json['createdBy'] == null ? undefined : InternalApiUserBasicDetailsFromJSON(json['createdBy']),
    };
}

export function InternalApiSegmentEventToJSON(json: any): InternalApiSegmentEvent {
    return InternalApiSegmentEventToJSONTyped(json, false);
}

export function InternalApiSegmentEventToJSONTyped(value?: InternalApiSegmentEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventType': InternalApiSegmentEventTypeToJSON(value['eventType']),
        'eventContent': value['eventContent'],
        'createdAt': value['createdAt'].toISOString(),
        'createdBy': InternalApiUserBasicDetailsToJSON(value['createdBy']),
    };
}

